import { ModelSagres } from "@/types/model-sagres";

export class FiltrosEditais extends ModelSagres {
  Banca: string;
  NrEdital: number | undefined;
  AnoEdital: number | undefined;
  Tipo: number | null;
  Situacao: number | null;;
  UGResponsavel: number | null;;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.Banca = obj.Banca;
      this.NrEdital = obj.NrEdital;
      this.AnoEdital = obj.AnoEdital;
      this.UGResponsavel = obj.UGResponsavel;
    }
  }

  limpar(): void {
    this.Banca = '';
    this.NrEdital = undefined;
    this.AnoEdital = undefined;
    this.Tipo = null;
    this.Situacao = null;
    this.UGResponsavel = null;
  }
}